import { useEffect, useState } from 'react'
import type { Rec } from '../../shared/schema'
import { navigate, useLocation } from './router'

/**
 * Estado del panel de edición de un módulo, sincronizado con la URL:
 *  ?abrir=<id>  abre un registro (lo usa el buscador y el panel principal)
 *  ?nuevo=1     abre el formulario vacío (accesos rápidos)
 */
export function useEditor(data: Rec[]) {
  const { path, query } = useLocation()
  const [editing, setEditing] = useState<Rec | null>(null)
  const [creating, setCreating] = useState<Record<string, any> | null>(null)

  const abrir = query.get('abrir')
  const nuevo = query.get('nuevo')
  useEffect(() => {
    if (abrir) { const r = data.find(x => x.id === abrir); if (r) { setEditing(r); navigate(path) } }
  }, [abrir, data])
  useEffect(() => {
    if (!nuevo) return
    const defaults: Record<string, any> = {}
    query.forEach((v, k) => { if (k !== 'nuevo') defaults[k] = v })
    setCreating(defaults); navigate(path)
  }, [nuevo])

  // Nota: mientras el panel está abierto no reemplazamos el registro con la versión sincronizada,
  // para no borrar lo que se está escribiendo. Si hubo cambios en Notion, al guardar aparece el aviso de conflicto.

  return {
    editing, creating,
    open: (r: Rec) => { setCreating(null); setEditing(r) },
    create: (defaults: Record<string, any> = {}) => { setEditing(null); setCreating(defaults) },
    close: () => { setEditing(null); setCreating(null) },
    isOpen: !!editing || !!creating,
  }
}
